import React, { Fragment, useCallback, useState } from 'react'
import * as S from './TableProductDivergence.styles'
import {
  Table,
  TableHead,
  TableHeadRow,
  TableHeadCell,
  TableBody,
  TableBodyCell,
  TableBodyRow
} from '../../../../../components/TableComponents'
import { WrapperTableItem, ButtonCaret } from '../Components'
import { SubTableProductQuantity } from '../SubTableProductQuantity'

export const TableProductDivergence = ({
  title,
  products,
  badge,
  updateTable
}) => {
  const [showRowDetail, setShowRowDetail] = useState(
    Array(products.length).fill(false)
  )

  const handleShowRowDetail = useCallback(
    (index) => {
      const newArray = showRowDetail.slice()
      newArray[index] = !newArray[index]
      setShowRowDetail(newArray)
    },
    [showRowDetail]
  )

  if (products.length === 0) {
    return null
  }

  return (
    <WrapperTableItem>
      <S.Title>{title}</S.Title>
      <Table>
        <TableHead>
          <TableHeadRow>
            <TableHeadCell flex={2}>Produto</TableHeadCell>
            <TableHeadCell>Status</TableHeadCell>
            <TableHeadCell isAction>Lotes</TableHeadCell>
          </TableHeadRow>
        </TableHead>
        <TableBody>
          {products.map((product, index) => {
            return (
              <Fragment key={product.id_produto_divergencia}>
                <TableBodyRow>
                  <TableBodyCell flex={2}>
                    {product.descricao_produto}
                  </TableBodyCell>
                  <TableBodyCell>{product.status}</TableBodyCell>
                  <TableBodyCell isAction>
                    <ButtonCaret
                      onClick={() => handleShowRowDetail(index)}
                      status={showRowDetail[index]}
                    />
                  </TableBodyCell>
                </TableBodyRow>
                {showRowDetail[index] && (
                  <S.SubTableRow>
                    <S.TDSubtable>
                      <SubTableProductQuantity
                        product={product}
                        badge={badge}
                        updateTable={updateTable}
                      />
                    </S.TDSubtable>
                  </S.SubTableRow>
                )}
              </Fragment>
            )
          })}
        </TableBody>
      </Table>
    </WrapperTableItem>
  )
}
